/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateReportRequest { 
    name: string;
    exportFrequencyId: number;
    exportTypeIds: Array<number>;
    recipientEmails: Array<string>;
    accountIds?: Array<string> | null;
    isSeparateProfitByAccounts?: boolean;
    id: string;
}

